var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DateAdapter } from '@angular/material/core';
import * as moment from 'moment';
/**
 * Date adapter that just works on birtdate type dates (no time or timezone) in ISO8601
 * short YYYY-MM-DD format
 */
function range(length, valueFunction) {
    var valuesArray = Array(length);
    for (var i = 0; i < length; i++) {
        valuesArray[i] = valueFunction(i);
    }
    return valuesArray;
}
var DateAdapterShortString = /** @class */ (function (_super) {
    __extends(DateAdapterShortString, _super);
    function DateAdapterShortString() {
        var _this = _super.call(this) || this;
        _this.fmt = 'YYYY-MM-DD';
        var locale = 'en';
        var momentLocaleData = moment.localeData(locale);
        _this._localeData = {
            firstDayOfWeek: momentLocaleData.firstDayOfWeek(),
            longMonths: momentLocaleData.months(),
            shortMonths: momentLocaleData.monthsShort(),
            dates: range(31, function (i) { return moment({ year: 2017, month: 0, date: i + 1 }).format('D'); }),
            longDaysOfWeek: momentLocaleData.weekdays(),
            shortDaysOfWeek: momentLocaleData.weekdaysShort(),
            narrowDaysOfWeek: momentLocaleData.weekdaysMin()
        };
        return _this;
    }
    DateAdapterShortString.prototype.parse = function (value, parseFormat) {
        if (value && typeof value === 'string') {
            return moment(value, parseFormat, this.locale).format(this.fmt);
        }
        return value
            ? moment(value)
                .locale(this.locale)
                .format(this.fmt)
            : null;
    };
    DateAdapterShortString.prototype.toIso8601 = function (date) {
        return moment(date, this.fmt).toISOString();
    };
    DateAdapterShortString.prototype.today = function () {
        return moment().format(this.fmt);
    };
    DateAdapterShortString.prototype.momentVal = function (date) {
        return moment(date, this.fmt);
    };
    DateAdapterShortString.prototype.addCalendarDays = function (date, days) {
        return moment(date, this.fmt)
            .add({ days: days })
            .format(this.fmt);
    };
    DateAdapterShortString.prototype.addCalendarMonths = function (date, months) {
        return moment(date, this.fmt)
            .add({ months: months })
            .format(this.fmt);
    };
    DateAdapterShortString.prototype.addCalendarYears = function (date, years) {
        return moment(date, this.fmt)
            .add({ years: years })
            .format(this.fmt);
    };
    DateAdapterShortString.prototype.clone = function (date) {
        return date;
    };
    DateAdapterShortString.prototype.createDate = function (year, month, date) {
        return moment({ year: year, month: month, date: date }).format(this.fmt);
    };
    DateAdapterShortString.prototype.format = function (date, format) {
        return moment(date, this.fmt).format(format);
    };
    DateAdapterShortString.prototype.month = function (date) {
        return this.momentVal(date).month();
    };
    DateAdapterShortString.prototype.year = function (date) {
        return this.momentVal(date).year();
    };
    DateAdapterShortString.prototype.fromIso8601 = function (val) {
        if (val.length === 10) {
            // already in the desired value
            return val;
        }
        return moment(val).format(this.fmt);
    };
    DateAdapterShortString.prototype.isDateInstance = function (obj) {
        return typeof obj === 'string';
    };
    DateAdapterShortString.prototype.isValid = function (date) {
        return this.momentVal(date).isValid();
    };
    DateAdapterShortString.prototype.invalid = function () {
        return 'Invalid Date';
    };
    DateAdapterShortString.prototype.getDateNames = function () {
        return this._localeData.dates;
    };
    DateAdapterShortString.prototype.getDayOfWeekNames = function (style) {
        if (style === 'long') {
            return this._localeData.longDaysOfWeek;
        }
        if (style === 'short') {
            return this._localeData.shortDaysOfWeek;
        }
        return this._localeData.narrowDaysOfWeek;
    };
    DateAdapterShortString.prototype.getMonthNames = function (style) {
        return style === 'long' ? this._localeData.longMonths : this._localeData.shortMonths;
    };
    DateAdapterShortString.prototype.getYearName = function (date) {
        return this.momentVal(date).format('YYYY');
    };
    DateAdapterShortString.prototype.getFirstDayOfWeek = function () {
        return this._localeData.firstDayOfWeek;
    };
    DateAdapterShortString.prototype.getNumDaysInMonth = function (date) {
        return this.momentVal(date).daysInMonth();
    };
    DateAdapterShortString.prototype.getYear = function (date) {
        return this.momentVal(date).year();
    };
    DateAdapterShortString.prototype.getMonth = function (date) {
        return this.momentVal(date).month();
    };
    DateAdapterShortString.prototype.getDate = function (date) {
        return this.momentVal(date).date();
    };
    DateAdapterShortString.prototype.getDayOfWeek = function (date) {
        return this.momentVal(date).day();
    };
    return DateAdapterShortString;
}(DateAdapter));
export { DateAdapterShortString };
